<script setup lang="ts">
interface Props {
  title?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <div class="floating-menu-popup menu-popup">
    <div class="floating-menu-popup__inner menu-popup__inner">
      <p
        v-if="!!props.title"
        class="floating-menu-popup__title"
      >
        {{ props.title }}
      </p>
      <ul class="floating-menu-popup__list">
        <slot name="list" />
      </ul>
    </div>
    <slot name="addition" />
  </div>
</template>

<style scoped lang="scss">
.floating-menu-popup {
  &__inner {
    display: flex;
    flex-direction: column;
    width: var(--gnb-sub-menu-width);
    max-height: calc(100vh - var(--gnb-header-height));
    overflow: hidden;
    background-color: var(--color-gray-06-00);
  }

  &:not(.shown) .floating-menu-popup__inner {
    border: none;
  }

  &__title {
    display: flex;
    gap: 8px;
    align-items: center;
    align-self: stretch;
    padding: 16px 16px 8px 20px;
    border-bottom: 1px solid var(--color-gray-05-03);
    background: var(--color-gray-07-01);
    font-size: 14px;
    font-weight: 700;
    line-height: 120%;
    color: var(--color-gray-01-11);
    white-space: nowrap;
  }

  &__list {
    max-height: 560px;
    padding: 8px;
    overflow: auto;
  }

  &__list:empty {
    padding: 0;
  }
}
</style>
